﻿import { getTranslations } from "../../translations.js";
import { Popup, PopupContent, PopupPosition } from "../../utilities/popup.js";
import { sendDataLayer } from "../ecommerce/ecommerce.js";

let instaPopup: Popup;
declare const UIkit: any;
let productInstagramSlideshowIndex = 0;

function OpenInstagramMedia(source)
{
    const mediaItem = $(source).closest(".js-instagram-item");
    let currentIndex = $(mediaItem).index();
    let curSource = $(mediaItem).parent().children();
    let showCartButton = $(mediaItem).closest(".product-media-holder").length > 0;

    if (showCartButton)
    {
        currentIndex = $(mediaItem).parent().index();
    }

    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'promotionClick',
        'ecommerce': {
            'items': [{
                'promotion_id': '' + $(mediaItem).data("url") + '',
                'promotion_name': '' + $(mediaItem).data("instagram-title") + '',
                'creative_name': '' + $(mediaItem).data("author") + '',
                'creative_slot': 'instagram_' + (currentIndex + 1) + '',
                'google_business_vertical': 'retail'
            }]
        }
    });

    if (!showCartButton)
    {
        sendDataLayer({
            'event': 'promotionClick',
            'category': 'Ecommerce',
            'action': 'click',
            'label': 'instagram'
        });
    }

    productInstagramSlideshowIndex = currentIndex;

    if (!instaPopup)
    {
        const contentWrapper = document.createElement("div");
        contentWrapper.className = "uk-slideshow-items c-instagram-popup__items";

        curSource.each(function ()
        {
            var url = $(this).data("url");
            var image = $(this).data("image");
            var descripton = $(this).data("description");
            var author = $(this).data("author");
            var authorUrl = $(this).data("author-url");
            var title = $(this).data("title");
            var productName = $(this).data("name");
            var productPhoto = $("#productmediaphoto").length > 0 ? $("#productmediaphoto").val() : $(this).attr("data-product-photo");
            var productURL = $(this).data("product-url") ?? "";
            var productPhotoDomain = $(this).data("product-photo-domain");
            var productPhotos = $(this).data("product-photos");
            var productNames = $(this).data("names");
            var productURLs = $(this).data("product-urls");
            var productID = $(this).data("pid");
            var articleID = parseInt($("#shopart").attr("value")) ?? $(this).data("aid");
            var price = $(this).data("price");
            var summary = $(this).data("summary");
            var brand = $(this).data("brand");

            var addToCartButton = "";
            var mediaButtonHtml = "";
            var mediaPostClass = "c-instagram-popup__media-post";
            if (showCartButton)
            {
                if (typeof (productID) == undefined)
                    productID = 0;

                if (typeof (articleID) == undefined)
                    articleID = 0;

                mediaButtonHtml =
                    "<div class=\"w-productcard-small__button\">" +
                    "{media-product-button}" +
                    "</div>";

                mediaPostClass += " productdetail-media-post";

                addToCartButton = "<a data-productid=\"" + productID + "\" data-articleid=\"" + articleID + "\" class=\"btn btn-green btn-icon-left btn-icon-cart add-cart-button article \" href=\"#\" onclick=\"addArticleToCart($(this), " + articleID + ", shopConfig().useAddToCartPopup, false, true, true); return false;\">" + getTranslations().inCartText + "</a>";
            }
            else
            {
                mediaButtonHtml =
                    "<a class=\"w-productcard__content-view-btn btn-link ic-chevron-right-aft p-linkicon f-primary-m tl-bold\" href=\"{product-url}\" title=\"media-product-name\">" +
                    getTranslations().showProductText +
                    "</a>";
            }

            var template =
                "<div class=\"c-instagram-popup__item\">" +
                "<div class=\"c-instagram-popup-col-1\">" +
                "<img src=\"{media-image}\" class=\"c-instagram-popup__image\" alt=\"{media-image-alt}\" width=\"600\" height=\"600\" />" +
                "</div>" +
                "<div class=\"c-instagram-popup-col-2\">" +
                "<div class=\"w-productcard w-productcard__small w-productcard--instagram\">" +
                "<div class=\"w-productcard__holder\">" +
                "<a class=\"w-productcard__image-holder c-instagram-popup-product__image\" href=\"{product-url}\">" +
                "<img class=\"w-productcard__image\" src=\"{media-product-name-img}\" alt=\"{media-product-name}\" width=\"432\" height=\"432\" />" +
                "</a>" +
                "<div class=\"w-productcard-small__content\">" +
                "<a class=\"w-productcard-small__name f-primary-m tl-bold\" href=\"{product-url}\">" +
                "{media-product-name}" +
                "</a>" + (!showCartButton ? "<span class=\"w-productcard-small__summary f-secondary-s\">" + (summary ?? "") + "</span>" : "") +
                "<div class=\"w-productcard-small__buttons\">" + (!showCartButton ? "<div class=\"w-productcard-small__price f-secondary-s\">" + getTranslations().txtPriceFrom + "<span class=\"f-primary-l\">" + (price ?? "") + "</span>" + "</div>" : "") + mediaButtonHtml +
                "</div>" +
                "</div>" +
                "</div>" +
                "{subproducts}" +
                (author && author.length > 0 ? "<div class=\"" + mediaPostClass + "\">" +
                    "<a tabindex=\"-1\" class=\"c-instagram-popup__author f-primary-s\" href=\"{media-post-author-href}\" target=\"_blank\"><span class=\"ic-instagram\"></span>@{media-post-author}</a>" +
                    "</div>" : "") +
                "</div>" +
                "</div>";

            template = template
                .replaceAll("{product-url}", productURL)
                .replaceAll("{media-image}", image)
                .replaceAll("{media-image-alt}", productName)
                .replaceAll("{media-product-name}", brand ?? productName)
                .replaceAll("{media-product-name-img}", productPhoto ? productPhoto.toString() : "")
                .replaceAll("{media-post-author-href}", authorUrl)
                .replaceAll("{media-post-author}", author)
                .replaceAll("{media-post-description}", descripton)
                .replaceAll("{media-product-title}", title)
                .replaceAll("{media-product-button}", addToCartButton);

            var subProductsHtml = [];

            // This media item has multiple products
            if (productPhotoDomain != '' && productPhotos != '' && productNames != '' && productURLs != '')
            {
                var productPhotosArray = productPhotos !== undefined ? productPhotos.split(',') : "";
                var productNamesArray = productNames !== undefined ? productNames.split(',') : "";
                var productURLsArray = productURLs !== undefined ? productURLs.split(',') : "";

                for (var i = 0; i < productPhotosArray.length; i++)
                {
                    if (typeof productPhotosArray[i] !== typeof (undefined) &&
                        typeof productNamesArray[i] !== typeof (undefined) &&
                        typeof productURLsArray[i] !== typeof (undefined))
                    {
                        var tmpTemplate =
                            "<div class=\"w-productcard__holder\">" +
                            "<div class=\"w-productcard__image-holder c-instagram-popup-product__image\">" +
                            "<img class=\"w-productcard__image\" src=\"{media-product-name-img}\" />" +
                            "</div>" +
                            "<div class=\"w-productcard-small__content\">" +
                            "<div class=\"w-productcard-small__name f-primary-m tl-bold\">" +
                            "{media-product-name}" +
                            "</div>" +
                            "<div class=\"w-productcard-small__buttons\">" +
                            "<div class=\"w-productcard-small__button\">" +
                            "<a class=\"btn btn-green btn-icon-left btn-icon-cart add-cart-button article\" href=\"{product-url}\">" + getTranslations().showProductText + "</a>" +
                            "</div>" +
                            "</div>" +
                            "</div>" +
                            "<div class=\"clear\"></div>" +
                            "</div>" +
                            "<div class=\"media-divider\"></div>";

                        tmpTemplate = tmpTemplate
                            .replaceAll("{product-url}", productURLsArray[i])
                            .replaceAll("{media-product-name}", productNamesArray[i])
                            .replaceAll("{media-product-name-img}", productPhotosArray ? productPhotoDomain + productPhotosArray[i] : "")
                            .replaceAll("{btn-width-class}", showCartButton ? "btn-full-width" : "");

                        subProductsHtml.push(tmpTemplate);
                    }
                }
            }

            template = template
                .replaceAll("{subproducts}", subProductsHtml.toString().replaceAll(">,<", "><"));

            contentWrapper.appendChild($(template).clone()[0]);
        });

        const slideShow = document.createElement("div");
        slideShow.appendChild(contentWrapper);

        const navigationHolder = document.createElement("div");
        navigationHolder.className = "c-instagram-popup__navigation";

        const btnPrev = document.createElement("a");
        btnPrev.setAttribute("uk-slideshow-item", "previous");
        btnPrev.className = "c-instagram-popup__prev";

        const btnNext = document.createElement("a");
        btnNext.setAttribute("uk-slideshow-item", "next");
        btnNext.className = "c-instagram-popup__next";

        navigationHolder.appendChild(btnPrev);
        navigationHolder.appendChild(btnNext);

        slideShow.appendChild(navigationHolder);

        instaPopup = new Popup({
            title: getTranslations().beInspiredText,
            content: slideShow,
            desktopPosition: PopupPosition.Center,
            closeButton: {
                label: getTranslations().txtClose
            },
            onShow: () =>
            {
                $("body").on("keyup", function (event)
                {
                    if (event.keyCode == 37)
                        btnPrev.click();
                    else if (event.keyCode == 39) // right
                        btnNext.click();
                });

                if (typeof (window.matchMedia) === "function" && window.matchMedia("screen and (max-width: 768px)").matches)
                    UIkit.slideshow(slideShow, { ratio: '1:2', finite: true }).show(productInstagramSlideshowIndex);
                else
                    UIkit.slideshow(slideShow, { ratio: '2:1', finite: true }).show(productInstagramSlideshowIndex);
            },
            onHide: () =>
            {
                $("body").off("keyup");
            }
        });
    }

    instaPopup.show();
};

(window as any).OpenInstagramMedia = OpenInstagramMedia;

function addProductToCartMedia(): void
{
    instaPopup?.hide();
    $(".add-cart-button:first").trigger("click");
}

(window as any).addProductToCartMedia = addProductToCartMedia;

const hideEmptyAuthor = () => {
    const $authors: JQuery<HTMLElement> = $(".p-instagram__author");

    if (!$authors) return;

    $authors.each((i, author) => {
        if ($(author).find("a") && $(author).find("a").text().trim() === "") author.remove();
    });
}

(window as any).hideAuthor = hideEmptyAuthor;

export const updateSideImage = () => {
    
    const media = document.querySelector(".product-media-wrapper");

    if (!media) return;

    var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            const mediaImage = document.querySelector(".product-media__section-image").querySelector("img");
            const image = document.querySelector(".product-gallery-item[data-imagetype=\"vrijstaand\"]").querySelector("img").cloneNode(true);

            mediaImage.replaceWith(image);

            const mediaHolderLength = document.querySelector(".product-media-holder").children.length;

            if (mediaHolderLength > 3) {
                document.querySelector(".product-media__section-image").classList.add("product-media__section-image--large")
            } else if (mediaHolderLength > 1) {
                document.querySelector(".product-media__section-image").classList.add("product-media__section-image--medium")
            }
        })
    })

    var config = { attributes: true, childList: true, characterData: true }

    observer.observe(media, config);
}


window.addEventListener("DOMContentLoaded", () => {
    hideEmptyAuthor();
    updateSideImage();
});

